type ILimitErrorObjectType = 'NotesNumber' | 'Usage' | 'Storage' | 'Attachment';

export interface ILimitError {
  limitSize: number;
  message: string;
  name: 'LimitError';
  objectGlobalId: string;
  objectSize: number;
  objectType: ILimitErrorObjectType;
}

export interface IAccessDeniedError {
  name: 'AccessDenied';
  message: string;
  reason: string;
}

/**
 * Container for errors that are returned from the backend
 */
export interface AppError {
  error: string | ILimitError | IAccessDeniedError;
}

export class ServerSideAppError extends Error {}

export class AppLimitError extends ServerSideAppError implements ILimitError {
  limitSize: number;
  override name: 'LimitError';
  objectGlobalId: string;
  objectSize: number;
  objectType: ILimitErrorObjectType;

  constructor(error: ILimitError) {
    super(error.message);
    this.limitSize = error.limitSize;
    this.message = error.message;
    this.name = error.name;
    this.objectGlobalId = error.objectGlobalId;
    this.objectSize = error.objectSize;
    this.objectType = error.objectType;
  }
}

export class AppAccessDeniedError extends ServerSideAppError implements IAccessDeniedError {
  override name: 'AccessDenied';
  reason: string;

  constructor(error: IAccessDeniedError) {
    super(error.message);
    this.message = error.message;
    this.name = error.name;
    this.reason = error.reason;
  }
}
